export default {
  apiKey: "AIzaSyAhOBKa0fYfhjxkclAQvxwMNRzvMPRYVRQ",
  authDomain: "bookreader-4f45a.firebaseapp.com",
  projectId: "bookreader-4f45a",
  storageBucket: "bookreader-4f45a.appspot.com",
  messagingSenderId: "421768575807",
  appId: "1:421768575807:web:2eb4e020a04d331950318a",
  measurementId: "G-LYDN4SP5NW",
};
